import type { Schema } from './api';

export const spartakSource = '06d82291-f09a-4993-902e-226ada6a55b3';
export const spartakEstimate = '768f429c-865c-5d50-8765-d258a675cf23';
export const spartakEstimateRevision = '4adb8f8e-66e1-508b-a79b-6759b935fb96';
const protocol = 'spartak-estimate-preparation-v1';
export const estimateHref = `/?project=${spartakEstimate}&revision=${spartakEstimateRevision}&tab=estimate`;
const object = (v: unknown): Record<string, unknown> | null => v !== null && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : null;
const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

/** Derive an authenticated local download only from a completed preparation's validated snapshot. */
export function estimatePreparation(job: Pick<Schema['JobOut'], 'kind' | 'status' | 'details'>) {
  const details = object(job.details.estimate_preparation);
  if (job.kind !== 'analyze' || details?.protocol !== protocol) return null;
  const groups = object(details.groups);
  const count = groups ? Object.keys(groups).length : 0;
  const total = typeof details.groups_total === 'number' ? details.groups_total : null;
  const id = details.package_snapshot_id;
  const ready = job.status === 'done' && details.status === 'prepared_for_professional_review'
    && typeof id === 'string' && uuid.test(id) && typeof details.sha256 === 'string' && /^[a-f0-9]{64}$/i.test(details.sha256);
  return { count, total, ready, href: ready ? `/api/v1/exports/${id}/download` : null };
}
